export default __webpack_public_path__ + "media/images/rin-965ac98ec0094ef14a130103e34f383f.png";